import { Form } from "@unform/web";
import { useRef } from "react";

import NexLogo from "Assets/Admin/NexLogo.svg";

import { HTTPErrorCallback } from "Helpers/Error";
import { hideEmail } from "Helpers/Util";

import UseServices from "Hooks/UseServices";

import PrimaryButton from "Components/Global/Buttons/Variants/Primary";
import Input from "Components/Global/Form/Input";
import TypographyHead from "Components/Global/Typography/Head";

import * as S from "../../../styles";
import * as SV from "./styles";

const Verification = ({
  loading,
  setLoading,
  getVerificationCode,
  setForgotPasswordStep,
  setVerificationCode,
  setUserId,
  email,
}) => {
  const formRef = useRef();
  const { api } = UseServices();

  const validateCode = (data) => {
    setLoading(true);
    api
      .post("/validate-password-code", { ...data, login: email })
      .then((response) => {
        setLoading(false);
        setVerificationCode(data.code);
        setUserId(response.data.user_id);
        setForgotPasswordStep("newPassword");
      })
      .catch((error) => {
        HTTPErrorCallback(error);
        setLoading(false);

        return formRef.current.setErrors({
          code: JSON.stringify({
            type: "error",
            message: "Código inválido!",
          }),
        });
      });
  };

  return (
    <S.Wrapper>
      <S.Row>
        <img src={NexLogo} alt="Movemeta Logo" />
        <TypographyHead
          dark
          title="Código de verificação"
          description={`Digite o código que enviamos para o email ${hideEmail(
            email,
          )}`}
        />
      </S.Row>
      <Form onSubmit={validateCode} ref={formRef}>
        <S.Row>
          <Input
            type="digit-separated"
            required
            name="code"
            label="Código de verificação"
            placeholder="9999"
            mask="9999"
            digits={4}
            disabled={loading}
          />

          <SV.SendCodeAgain onClick={() => !loading && getVerificationCode()}>
            Ainda não recebeu o código? Enviar novamente
          </SV.SendCodeAgain>
          <PrimaryButton text="Verificar" type="submit" disabled={loading} />
        </S.Row>
      </Form>
    </S.Wrapper>
  );
};

export default Verification;
